import { useQuery } from "@tanstack/react-query";
import { UserService } from "@/services/users/UserService";
import { UserUsageSummaryMap } from "@/types/stats";

export const useUsersUsageSummary = (userIds: string[]) => {
  const sortedIds = [...userIds].sort();

  return useQuery<UserUsageSummaryMap>({
    queryKey: ["users-usage-summary", sortedIds],
    queryFn: () => UserService.getUsageSummary(sortedIds),
    enabled: sortedIds.length > 0,
    staleTime: 60_000,
  });
};
